import { SetAdminQueryFlags } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { AdminQueryFlagsState } from './types'

const getInitialState = (): AdminQueryFlagsState => ({
  showAllFields: false,
})

export const adminQueryFlagsReducer = (
  state: AdminQueryFlagsState = getInitialState(),
  action: Action<Partial<AdminQueryFlagsState>>,
): AdminQueryFlagsState => {
  switch (action.type) {
    case SetAdminQueryFlags.type:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
